import React, { PropsWithChildren } from 'react'

export const LineChartSVG = React.forwardRef<
  SVGElement,
  PropsWithChildren<any>
>(({ width, height, children, ...rest }, ref) => {
  return (
    <svg
      ref={ref}
      preserveAspectRatio="xMinYMin meet"
      viewBox={`0 0 ${width} ${height}`}
      {...rest}
    >
      {children}
    </svg>
  )
})

LineChartSVG.displayName = 'LineChartSVG'
